module.exports = __webpack_public_path__ + "static/media/BereavementLeave.e9cc91ad.svg";